import Jumbotron from './Jumbotron';
import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import axios from 'axios';
import Swal from "sweetalert2";
import Pagination from './Pagination';

import img1 from './../components/assets/images/blog-2.jpg';
import img2 from './../components/assets/images/blog-3.jpg';
const modules = {
    toolbar: [
        [{ header: '1' }, { header: '2' }, { font: [] }],
        [{ size: [] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        ['link', 'image', 'video'],
        ['clean'],
    ],
    clipboard: {
        matchVisual: false,
    },
};

const formats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video',
];
const Blog = () => {
    const itemsPerPage = 5;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editorHtml, setEditorHtml] = useState('');
    const [userData, setUserData] = useState(null);
    const [blogs, setBlogs] = useState([]);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [formData, setFormData] = useState({
        // ModifiedBy: '',
        Summary: '',
        // FileName: 'string',
        // CreatedOn: '2024-12-03T15:05:25.716Z',
        // ModifiedOn: '2024-12-03T15:05:25.716Z',
        Title: '',
        Description: '',
        // CreatedBy: '',
        file: ''
    });
    useEffect(() => {
        // Retrieve the user data from localStorage
        const storedUserData = localStorage.getItem("userData");
        if (storedUserData) {
            setUserData(JSON.parse(storedUserData));
        }
        fetchBlogs();
    }, []);
    const totalPages = Math.ceil(blogs.length / itemsPerPage);
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    const displayedBlogs = blogs.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const fetchBlogs = async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("token");
            const response = await axios.get("https://azebrahimi.eastus.cloudapp.azure.com/api/Blog/GetAllBlogs", {
                headers: {
                    'accept': '*/*',
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`, // Include the token here
                },
            });
            console.log("Blogs fetched successfully:", response.data);
            setBlogs(response.data.reverse());
        } catch (err) {
            console.error("Error fetching blogs:", err);
            setError("Failed to fetch blogs. Please try again later.");
        } finally {
            setLoading(false);
        }
    };
    const handleChange = (html) => {
        setEditorHtml(html);
        setFormData({ ...formData, Description: html })
    };
    const toggleModal = () => {
        setEditorHtml('');
        setIsModalOpen(!isModalOpen);
    };
    const handleSave = async () => {
        // Check if required fields are provided
        const { Summary, Title, Description, file } = formData;
        if (!Summary || !Title || !Description || !file) {
            toastError("Please fill in all required fields: Summary, Title, Description, and file.");
            return;
        }
        const token = localStorage.getItem("token");
        const formDataToSend = new FormData();
        Object.keys(formData).forEach((key) => {
            formDataToSend.append(key, formData[key]);
        });

        setLoading(true);
        axios.post(
            'https://azebrahimi.eastus.cloudapp.azure.com/api/Blog/UploadBlog',
            formDataToSend,
            {
                headers: {
                    'accept': '*/*',
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`, // Include the token here
                },
            }
        )
            .then((response) => {
                setLoading(false);
                fetchBlogs();
                console.log('Response:', response.data);
                toastSuccess(response.data.message);
                toggleModal(); // Close the modal on successful save
            })
            .catch((error) => {
                setLoading(false);
                toastError("Failed to create blog. Please try again later.");
                console.error('Error:', error);
            });
    };
    const deleteBlog = async (id) => {
        try {
            const token = localStorage.getItem("token");

            setLoading(true);
            const response = await axios.delete(
                `https://azebrahimi.eastus.cloudapp.azure.com/api/Blog/DeleteBlog/${id}`, {
                headers: {
                    'accept': '*/*',
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`, // Include the token here
                },
            }
            ); // Replace with your API endpoint
            toastSuccess(response.data.message);
        } catch (err) {
            console.error("Error fetching blog:", err);
            toastError("Failed to delete blog. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const toastSuccess = (title, text = "") => {
        Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 4000,
            title: title,
            text: text,
            icon: 'success',
            timerProgressBar: true
        });
    }
    const toastError = (title, text = "") => {
        Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: false,
            timer: 4000,
            title: title,
            text: text,
            icon: 'error',
            timerProgressBar: true
        });
    }
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        // Get hours, minutes, and seconds
        let hours = date.getHours();
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        // Determine AM/PM
        const period = hours >= 12 ? 'PM' : 'AM';
        // Convert to 12-hour format
        hours = hours % 12 || 12; // If hours is 0 (midnight), convert to 12
        // Format hours with leading zero
        hours = String(hours).padStart(2, '0');
      
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds} ${period}`;
      };
    if (loading) return <h4 className='text-center'>Loading please wait...</h4>;
    if (error) return <h4 className='text-center'>Error: {error}</h4>;
    return (
        <>
            {/* <Jumbotron /> */}
            <div className="page-padd mt-3">
                <section className="blog">
                    <div className="container">
                        <div className="row">
                            {userData ? (<div className='col-md-12 mb-3'>
                                <button type="button" className="btn btn-primary float-right" onClick={toggleModal}>
                                    Start a post
                                </button>
                            </div>) : null}
                            {displayedBlogs.length > 0 ? (
                                <div className="row" data-aos="fade-left" data-aos-delay="300">
                                    {displayedBlogs.map((blog) => (
                                        <>
                                            <div className="col-sm-6 col-6 box-2">
                                                <figure className="figure">
                                                    <Link to={`/single_blog/${blog.blogId}`}><img src={blog.fileName || img1} className="figure-img img-fluid" alt="blog" /></Link>
                                                </figure>
                                            </div>
                                            <div className="col-sm-6 col-6 box-3">
                                                <h4><Link to={`/single_blog/${blog.blogId}`}>{blog.title}</Link> <br /><mark style={{ fontSize: "14px" }}>{formatDate(blog.createdOn)}</mark></h4>
                                                <h5>{blog.summary}</h5>
                                                <Link to={`/single_blog/${blog.blogId}`} className="btn btn-success">Read</Link>
                                                {userData ? (
                                                    <Link onClick={() => deleteBlog(blog.blogId)} className="btn btn-danger ml-2">Delete</Link>
                                                ) : null}
                                            </div>
                                        </>
                                        //</div>
                                        // <div className='col-md-4' key={blog.blogId}>
                                        //     <div class="card mb-2">
                                        //         {/* <h5 class="card-header">Featured</h5> */}
                                        //         <div class="card-body">
                                        //             <h4 class="card-title">{blog.title}</h4>
                                        //             <p style={{width:"300px"}} class="card-text">{blog.summary}</p>
                                        //             <Link to={`/single_blog/${blog.blogId}`} className="btn btn-success"> + more </Link>
                                        //         </div>
                                        //     </div>
                                        // </div>
                                        // <div className="row"  key={blog.blogId}>
                                        //     <div className="col-sm-6 col-6 box-2">
                                        //         <figure className="figure">
                                        //             <a href="blog_single.html"><img src={img1} className="figure-img img-fluid" alt="blog" /></a>
                                        //         </figure>
                                        //     </div>
                                        //     <div className="col-sm-6 col-6 box-3">
                                        //         <h4><a href="blog_single.html">{blog.title}</a></h4>
                                        //         <h5>{blog.summary}</h5>
                                        //         <Link to="/single_blog" className="btn btn-success">+ more</Link>
                                        //     </div>
                                        // </div>
                                    ))}
                                    <div className='col-md-12'>  <Pagination
                                        totalPages={totalPages}
                                        currentPage={currentPage}
                                        onPageChange={handlePageChange}
                                    /></div>
                                </div>
                            ) : (
                                <h4 className='text-center'>No blogs found.</h4>
                            )}
                        </div>
                    </div>
                </section>
                <div className="mt-3">
                    <iframe frameBorder="0" height="300" title="myFrame"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3020.3113589675813!2d-73.57774648414325!3d40.79915127932243!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c286b96a1b2727%3A0xad943160e075b92f!2sNew+Academic+Building+at+SUNY+Old+Westbury!5e0!3m2!1sen!2sus!4v1513701666413"
                        className="iframeStyle">
                    </iframe>
                </div>
            </div>
            {isModalOpen && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Start a post</h5>
                                <button type="button" className="close" onClick={toggleModal}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body" style={{ height: '450px', overflow: 'auto' }}>
                                <div class="form-group">
                                    <label>Title<sup className='text-danger'>*</sup></label>
                                    <input class="form-control"
                                        type="text"
                                        maxLength={50}
                                        value={formData.Title}
                                        onChange={(e) => setFormData({ ...formData, Title: e.target.value })}
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Summary<sup className='text-danger'>*</sup></label>
                                    <textarea
                                        className="form-control"
                                        rows="3"
                                        maxLength={150}
                                        value={formData.Summary}
                                        onChange={(e) => setFormData({ ...formData, Summary: e.target.value })}
                                        placeholder="Enter a short summary"
                                    ></textarea>
                                </div>

                                <div className="form-group">
                                    <label>Upload Image<sup className='text-danger'>*</sup></label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept="image/*"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            setFormData({ ...formData, file });
                                        }}
                                    />
                                </div>
                                <ReactQuill
                                    theme="snow"
                                    onChange={handleChange}
                                    value={editorHtml}
                                    modules={modules}
                                    formats={formats}
                                    bounds=".app"
                                    placeholder={"What do you want to talk about?"}
                                />
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={toggleModal}>
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSave}
                                    disabled={loading}
                                >
                                    {loading ? 'Saving...' : 'Save'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Blog;